<template>
  <div
    :class="['image-gallery', { 'image-gallery--grid': !enableSwiperView, 'image-gallery--single-image': imageGallery.length === 1 }]"
    :data-stio-ab-image-variant="abImageVariant"
  >
    <!-- Swiper layout -->
    <div
      v-if="enableSwiperView"
      ref="gallerySwiper"
      :class="['image-gallery__carousel', 'swiper-container', { 'compress': imageGallery.length > 1 }]"
    >
      <div class="image-gallery__swiper">
        <div
          v-for="(image, index) in imageGallery"
          :key="index"
          :class="['image-gallery__swiper-slide', { 'image-gallery__swiper-slide-single-image': imageGallery.length === 1 }]"
        >
          <button
            class="image-gallery__expand swiper-no-swiping"
            type="button"
            aria-label="Open fullscreen gallery"
            @click.stop.prevent="openMediaDialog(index)"
            @pointerdown.stop
            @mousedown.stop
            @touchstart.stop
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.8747 8.75018C11.8747 8.91594 11.8088 9.07491 11.6916 9.19212C11.5744 9.30933 11.4154 9.37518 11.2497 9.37518H9.37469V11.2502C9.37469 11.4159 9.30884 11.5749 9.19163 11.6921C9.07442 11.8093 8.91545 11.8752 8.74969 11.8752C8.58393 11.8752 8.42496 11.8093 8.30775 11.6921C8.19054 11.5749 8.12469 11.4159 8.12469 11.2502V9.37518H6.24969C6.08393 9.37518 5.92496 9.30933 5.80775 9.19212C5.69054 9.07491 5.62469 8.91594 5.62469 8.75018C5.62469 8.58442 5.69054 8.42545 5.80775 8.30824C5.92496 8.19103 6.08393 8.12518 6.24969 8.12518H8.12469V6.25018C8.12469 6.08442 8.19054 5.92545 8.30775 5.80824C8.42496 5.69103 8.58393 5.62518 8.74969 5.62518C8.91545 5.62518 9.07442 5.69103 9.19163 5.80824C9.30884 5.92545 9.37469 6.08442 9.37469 6.25018V8.12518H11.2497C11.4154 8.12518 11.5744 8.19103 11.6916 8.30824C11.8088 8.42545 11.8747 8.58442 11.8747 8.75018ZM17.9419 17.9424C17.8838 18.0005 17.8149 18.0466 17.739 18.078C17.6632 18.1095 17.5818 18.1257 17.4997 18.1257C17.4176 18.1257 17.3362 18.1095 17.2604 18.078C17.1845 18.0466 17.1155 18.0005 17.0575 17.9424L13.1466 14.0306C11.7854 15.1644 10.0395 15.7298 8.27214 15.6091C6.50475 15.4884 4.85192 14.691 3.65748 13.3828C2.46304 12.0745 1.81895 10.3561 1.8592 8.5851C1.89945 6.81406 2.62094 5.12671 3.87358 3.87407C5.12622 2.62143 6.81357 1.89994 8.58462 1.85969C10.3557 1.81944 12.074 2.46353 13.3823 3.65797C14.6906 4.85241 15.488 6.50524 15.6086 8.27263C15.7293 10.04 15.1639 11.7859 14.0302 13.1471L17.9419 17.058C18 17.116 18.0461 17.185 18.0775 17.2608C18.109 17.3367 18.1252 17.418 18.1252 17.5002C18.1252 17.5823 18.109 17.6636 18.0775 17.7395C18.0461 17.8154 18 17.8843 17.9419 17.9424ZM8.74969 14.3752C9.86221 14.3752 10.9497 14.0453 11.8748 13.4272C12.7998 12.8091 13.5208 11.9306 13.9465 10.9028C14.3723 9.87494 14.4836 8.74394 14.2666 7.65279C14.0496 6.56165 13.5138 5.55937 12.7272 4.7727C11.9405 3.98603 10.9382 3.4503 9.84707 3.23326C8.75593 3.01622 7.62493 3.12761 6.59709 3.55336C5.56926 3.9791 4.69076 4.70007 4.07267 5.62509C3.45459 6.55012 3.12469 7.63766 3.12469 8.75018C3.12634 10.2415 3.71951 11.6713 4.77404 12.7258C5.82857 13.7804 7.25835 14.3735 8.74969 14.3752Z" fill="#767676"/>
            </svg>
          </button>

          <ImageMagnifier
            v-if="!isVideoItem(image)"
            class="image-gallery__image"
            :key="image.src"
            :product-image="image.src"
            :image-index="index"
            :aspect-ratio="isGiftCard ? 1.0352 : 0.806"
            :disable="true"
          />

          <!-- Uploaded file: poster + play opens dialog -->
          <div
            v-else-if="image.sources?.length"
            class="image-gallery__video-wrapper"
            @click="openMediaDialog(index)"
          >
            <ImageMagnifier
              v-if="image.src"
              class="image-gallery__image"
              :key="image.src"
              :product-image="image.src"
              :image-index="index"
              :aspect-ratio="isGiftCard ? 1.0352 : 0.806"
              :disable="true"
            />
            <div v-else class="image-gallery__video-poster-fallback" aria-hidden="true" />
            <button
              class="image-gallery__video-play swiper-no-swiping"
              type="button"
              aria-label="Play video"
              @click.stop.prevent="openMediaDialog(index)"
              @pointerdown.stop
              @mousedown.stop
              @touchstart.stop
            >
              <svg width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="42" height="34" rx="6" fill="black"/>
                <path d="M17 10.14V24.14L28 17.14L17 10.14Z" fill="white"/>
              </svg>
            </button>
          </div>

          <!-- Vimeo URL only: embed player like before -->
          <div v-else-if="image.link" class="image-gallery__video-wrapper">
            <iframe
              :src="getVimeoUrl(image.link)"
              class="image-gallery__fit-video"
              width="100%"
              height="100%"
              loading="lazy"
              tabindex="-1"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>

      <div class="image-gallery__nav image-gallery__prev" tabindex="0">
        <svg class="image-gallery__prev-icon">
          <use xlink:href="#icon-prev" />
        </svg>
      </div>
      <div class="image-gallery__nav image-gallery__next" tabindex="0">
        <svg class="image-gallery__next-icon">
          <use xlink:href="#icon-next" />
        </svg>
      </div>
    </div>

    <!-- Pagination dots (mobile only) -->
    <div v-if="enableSwiperView && imageGallery.length > 1" class="image-gallery__pagination">
      <span
        v-for="(image, index) in imageGallery"
        :key="index"
        :class="['image-gallery__dot', { 'image-gallery__dot--active': currentSlide === index }]"
        @click="goToSlide(index)"
      >
        <svg
          v-if="isVideoItem(image)"
          class="image-gallery__dot-play"
          width="6"
          height="8"
          viewBox="0 0 6 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.544922 0.501953L5.45703 3.8916L5.45898 3.89355C5.46332 3.89651 5.47375 3.90551 5.4834 3.9248C5.49313 3.94432 5.50006 3.9702 5.5 3.99902V4.00098C5.50006 4.0298 5.49313 4.05568 5.4834 4.0752C5.47375 4.09449 5.46332 4.10349 5.45898 4.10645L5.45703 4.1084L0.544922 7.49805H0.543945L0.517578 7.4668C0.512322 7.4567 0.508054 7.44474 0.504883 7.43164L0.5 7.38867V0.611328C0.500039 0.580795 0.507059 0.553406 0.517578 0.533203C0.528012 0.513168 0.539697 0.504633 0.543945 0.501953V0.500977L0.544922 0.501953Z"
            :fill="currentSlide === index ? '#27863A' : '#A0A0A0'"
            :stroke="currentSlide === index ? '#27863A' : '#A0A0A0'"
          />
        </svg>
      </span>
    </div>

    <!-- Grid layout (non-swiper) -->
    <div
      v-if="!enableSwiperView"
      v-for="(image, index) in imageGallery"
      :key="index"
      class="image-gallery__grid-card"
      @click="openMediaDialog(index)"
    >
      <ImageMagnifier
        v-if="!isVideoItem(image)"
        class="image-gallery__image"
        :key="image.src"
        :product-image="image.src"
        :image-index="index"
        :aspect-ratio="isGiftCard ? 1.0352 : 0.806"
        :disable="true"
      />

      <!-- Uploaded file: poster + play opens dialog -->
      <div v-else-if="image.sources?.length" class="image-gallery__video-wrapper">
        <ImageMagnifier
          v-if="image.src"
          class="image-gallery__image"
          :key="image.src"
          :product-image="image.src"
          :image-index="index"
          :aspect-ratio="isGiftCard ? 1.0352 : 0.806"
          :disable="true"
        />
        <div v-else class="image-gallery__video-poster-fallback" aria-hidden="true" />
        <button
          class="image-gallery__video-play"
          type="button"
          aria-label="Play video"
          @click.stop.prevent="openMediaDialog(index)"
        >
          <svg width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="42" height="34" rx="6" fill="black"/>
            <path d="M17 10.14V24.14L28 17.14L17 10.14Z" fill="white"/>
          </svg>
        </button>
      </div>

      <!-- Vimeo URL only: embed player like before -->
      <div v-else-if="image.link" class="image-gallery__video-wrapper">
        <iframe
          :src="getVimeoUrl(image.link)"
          class="image-gallery__fit-video"
          width="100%"
          height="100%"
          loading="lazy"
          tabindex="-1"
          aria-hidden="true"
        />
      </div>
    </div>

    <!-- Media Dialog -->
    <MediaDialog
      v-if="isMediaDialogOpen"
      :isOpen="isMediaDialogOpen"
      :gallery="dialogGallery"
      :initialIndex="mediaDialogIndex"
      :isGiftCard="isGiftCard"
      :isDesktopScreen="isDesktopScreen"
      :playUnmuted="playUnmutedOnOpen"
      @close="closeMediaDialog"
    />
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted, reactive, watch } from 'vue';
  import { useStore } from 'vuex';
  import ZoomImage from '../../global/zoom-image.vue';
  import ImageMagnifier from '../../global/image-magnifier.vue';
  import MediaDialog from './media-dialog.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, EffectFade, Thumbs } from 'swiper/core';

  SwiperCore.use([Navigation, EffectFade, Thumbs]);

  // Shoplift: studio vs environmental PDP gallery imagery
  const STUDIO_VS_ENVIRONMENTAL_ORIGINAL_ID = '01a11713-68ef-71e2-8947-d4d736c0bd31';
  const STUDIO_VS_ENVIRONMENTAL_VARIANT_ID = '01a11713-68ef-7554-b718-e237f493a0ee';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },
    isDesktopScreen: {
      type: Boolean,
      default: false,
    },
    slidesPerView: {
      type: Number,
      default: null,
    },
    showSlidesCount: {
      type: Boolean,
      default: false,
    },
    disableZoom: {
      type: Boolean,
      default: false,
    },
    slidesOffsetAfter: {
      type: Number,
      default: null,
    },
    isGiftCard: {
      type: Boolean,
      default: false,
    }
  });

  const store = useStore();
  const { product, isDesktopScreen, slidesPerView, slidesOffsetAfter } = toRefs(props);
  const productForm = ref(store.state.pdp.productForm);
  const firstOption = product.value.options[0].name;
  const gallerySwiper = ref(null);
  const currentSlide = ref(0);
  const swiperInstance = ref(null);
  const isMediaDialogOpen = ref(false);
  const mediaDialogIndex = ref(0);
  const playUnmutedOnOpen = ref(false);

  const enableSwiperView = computed(() => !isDesktopScreen.value);

  const cachedEnvTestState = window.__stioStudioVsEnvironmentalTestState;
  const showEnvironmentalImagery = ref(cachedEnvTestState?.showEnvironmental === true);
  const isInStudioVsEnvironmentalTest = ref(cachedEnvTestState?.inTest === true);

  const environmentalImages = computed(() => product.value.environmental_images || []);

  const getStudioVsEnvironmentalTestState = async () => {
    const inactiveState = { showEnvironmental: false, inTest: false };
    if (!environmentalImages.value.length || !window.shoplift) return inactiveState;
    if (window.__stioStudioVsEnvironmentalTestState) return window.__stioStudioVsEnvironmentalTestState;
    if (!window.__stioStudioVsEnvironmentalTestPromise) {
      window.__stioStudioVsEnvironmentalTestPromise = Promise.all([
        window.shoplift.isHypothesisActive(STUDIO_VS_ENVIRONMENTAL_VARIANT_ID).then(Boolean).catch(() => false),
        window.shoplift.isHypothesisActive(STUDIO_VS_ENVIRONMENTAL_ORIGINAL_ID).then(Boolean).catch(() => false),
      ]).then(([variantActive, originalActive]) => {
        const testState = { showEnvironmental: variantActive, inTest: variantActive || originalActive };
        window.__stioStudioVsEnvironmentalTestState = testState;
        return testState;
      }).catch(() => inactiveState);
    }
    return window.__stioStudioVsEnvironmentalTestPromise;
  };

  const setStudioVsEnvironmentalTestState = async () => {
    const testState = await getStudioVsEnvironmentalTestState();
    showEnvironmentalImagery.value = testState.showEnvironmental;
    isInStudioVsEnvironmentalTest.value = testState.inTest;
  };

  const decodeHtmlEntities = (value) =>
    value
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // The environmental set only replaces studio when the selected color is actually covered;
  // otherwise the shopper falls back to studio (same silent-fallback policy as the PLP test).
  const hasEnvironmentalColorMatch = computed(() => {
    const images = environmentalImages.value;
    if (!images.length) return false;
    const { Color } = productForm.value || {};
    if (!Color) return true;
    const colorPattern = new RegExp(`^\\s*(${escapeRegExp(Color.toLowerCase())}(\\s+alternative)?)\\s*$`);
    return images.some((image) => image.alt && colorPattern.test(decodeHtmlEntities(image.alt.toLowerCase())));
  });

  const useEnvironmentalImagery = computed(
    () => showEnvironmentalImagery.value && hasEnvironmentalColorMatch.value
  );

  // What the shopper actually sees — for Elevar/GTM attribution, same convention as the PLP card test
  const abImageVariant = computed(() => {
    if (!isInStudioVsEnvironmentalTest.value) return null;
    return useEnvironmentalImagery.value ? 'environmental' : 'studio';
  });

  const getProductImageData = () => {
    const { title, images } = product.value;
    const { Color, Town } = productForm.value || {};
    const sourceImages = useEnvironmentalImagery.value ? environmentalImages.value : images;
    return window.getProductImages(sourceImages, Color, title, Town);
  };

  const normalizeMediaUrl = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      if (typeof value.url === 'string') return value.url;
      if (typeof value.src === 'string') return value.src;
    }
    return '';
  };

  const getFitVideoData = () => {
    const { fit_video_url, fit_video_placeholder, fit_video_file } = product.value.fit_info || {};
    const sources = fit_video_file?.sources?.filter((source) => source?.url) || [];
    const poster =
      normalizeMediaUrl(fit_video_placeholder) ||
      normalizeMediaUrl(fit_video_file?.preview_image) ||
      '';
    const videoUrl = normalizeMediaUrl(fit_video_url);

    // Prefer uploaded Shopify video file over Vimeo URL when present
    if (sources.length) {
      const primary = sources[0];
      return {
        src: poster,
        alt: 'Fit Video',
        sources,
        isVideo: true,
        aspectRatio:
          primary?.width && primary?.height ? primary.width / primary.height : null,
      };
    }

    if (videoUrl) {
      return {
        src: poster,
        alt: 'Fit Video',
        link: videoUrl,
        isVideo: true,
      };
    }

    return null;
  };

  const isVideoItem = (item) => !!(item?.isVideo || item?.link || item?.sources?.length);

  // 1-based metafield position → clamped insert index. Invalid/missing → default to 2nd slot.
  const resolveVideoInsertIndex = (positionValue, imageCount) => {
    const position = parseInt(positionValue, 10);
    let insertIndex = isNaN(position) || position < 1 ? 1 : position - 1;
    if (insertIndex > imageCount) {
      insertIndex = imageCount;
    }
    return insertIndex;
  };

  const buildGalleryWithVideoAt = (positionValue) => {
    const imageData = getProductImageData();
    const videoData = getFitVideoData();
    if (!videoData) return imageData;

    const insertIndex = resolveVideoInsertIndex(positionValue, imageData.length);
    imageData.splice(insertIndex, 0, videoData);
    return imageData;
  };

  const imageGallery = computed(() => {
    const { fit_video_position } = product.value.fit_info || {};
    return buildGalleryWithVideoAt(fit_video_position);
  });

  // Dialog can place the video independently via video_position_in_zoom_in_dialog.
  // If unset, keep the same order as the media gallery.
  const dialogGallery = computed(() => {
    const { fit_video_position, video_position_in_zoom_in_dialog } = product.value.fit_info || {};
    const dialogPosition = parseInt(video_position_in_zoom_in_dialog, 10);
    if (!isNaN(dialogPosition) && dialogPosition >= 1) {
      return buildGalleryWithVideoAt(dialogPosition);
    }
    return buildGalleryWithVideoAt(fit_video_position);
  });

  const mapGalleryIndexToDialogIndex = (galleryIndex) => {
    const gallery = imageGallery.value;
    const dialog = dialogGallery.value;
    const clicked = gallery[galleryIndex];
    if (!clicked) return 0;

    if (isVideoItem(clicked)) {
      const videoIndex = dialog.findIndex((item) => isVideoItem(item));
      return videoIndex >= 0 ? videoIndex : 0;
    }

    // Match the Nth non-video image so dialog/gallery position differences stay aligned.
    const imageOrdinal = gallery.slice(0, galleryIndex).filter((item) => !isVideoItem(item)).length;
    let seen = 0;
    const dialogIndex = dialog.findIndex((item) => {
      if (isVideoItem(item)) return false;
      if (seen === imageOrdinal) return true;
      seen += 1;
      return false;
    });
    return dialogIndex >= 0 ? dialogIndex : 0;
  };

  const fitNote = computed(() => {
    return product.value.variants.find((prod) => prod.fit_note && prod['option1'] === productForm.value[firstOption])
      ?.fit_note;
  });

  const galleryCarousel = computed(() => {
    return {
      slidesPerView: slidesPerView.value ?? (enableSwiperView.value && imageGallery.value.length > 1 ? 1.3 : 1),
      spaceBetween: 8,
      slidesOffsetAfter: slidesOffsetAfter.value ?? imageGallery.value.length > 1 ? 16 : 0,
      wrapperClass: 'image-gallery__swiper',
      slideClass: 'image-gallery__swiper-slide',
      threshold: 8,
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: '.image-gallery__next',
        prevEl: '.image-gallery__prev',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: `Go to previous carousel slide of the product ${product.value.title}`,
        nextSlideMessage: `Go to next carousel slide of product ${product.value.title}`,
        itemRoleDescriptionMessage: `This is a product carousel for one of the variant of ${product.value.title}`,
      },
      on: {
        slideChange: function () {
          currentSlide.value = this.realIndex;
        },
      },
    };
  });

  onMounted(() => {
    setStudioVsEnvironmentalTestState();

    if (enableSwiperView.value) {
      initializeSwipers();
    }
  });

  const initializeSwipers = () => {
    swiperInstance.value = new Swiper(gallerySwiper.value, galleryCarousel.value);
    currentSlide.value = swiperInstance.value.realIndex;
  };

  const showFitNote = (index) => {
    if (fitNote.value) {
      return imageGallery.value.length > 1 ? index === 1 : index === 0;
    }

    return false;
  };

  const getVimeoUrl = (url) => {
    const normalized = typeof url === 'string' ? url : normalizeMediaUrl(url);
    if (!normalized) return '';

    const videoId = normalized.split('/').filter(Boolean).pop();
    if (!videoId) return '';

    const baseUrl = `https://player.vimeo.com/video/${videoId}`;

    const params = new URLSearchParams({
      autoplay: 1,
      loop: 1,
      muted: 1,
      api: 1,
      player_id: `carousel-${videoId}`,
      controls: 1,
      title: 0,
      byline: 0,
      portrait: 0,
    });

    return `${baseUrl}?${params.toString()}`;
  };

  const goToSlide = (index) => {
    if (swiperInstance.value) {
      swiperInstance.value.slideTo(index);
    }
  };

  const openMediaDialog = (galleryIndex) => {
    const dialogIndex = mapGalleryIndexToDialogIndex(galleryIndex);
    mediaDialogIndex.value = dialogIndex;
    const dialogItem = dialogGallery.value[dialogIndex];
    playUnmutedOnOpen.value = !!(dialogItem?.sources?.length);
    isMediaDialogOpen.value = true;
  };

  const closeMediaDialog = () => {
    isMediaDialogOpen.value = false;
    playUnmutedOnOpen.value = false;
  };

  watch(imageGallery, () => {
    if (enableSwiperView.value) {
      setTimeout(() => {
        if (!gallerySwiper.value) return;
        swiperInstance.value?.destroy?.(true, true);
        swiperInstance.value = null;
        initializeSwipers();
      }, 100);
    }
  });
</script>
